import script from "./mainTop.vue?vue&type=script&setup=true&lang=js"
export * from "./mainTop.vue?vue&type=script&setup=true&lang=js"

import "./mainTop.vue?vue&type=style&index=0&id=564badcd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564badcd"]])

export default __exports__